module.exports = __webpack_public_path__ + "img/video_fm_ny.ddeca87d.jpg";